import { AxiosResponse } from "axios";
import { useEffect } from "react";
import { useContext, useRef, useState } from "react";
import { AdminFrame } from "views/common/AdminFrame";
import { delApiDataWithToken, getApiDataWithToken, postApiDataWithToken } from "views/utils/CallApi";
import { CtxAuth } from "views/utils/Contexts";
import * as mb from "views/common/MessageBox";
import * as Validation from "views/utils/Validation";
import { getRef, setRef } from "views/utils/InputHelp";
import { useHistory } from 'react-router-dom';
import { Dialog } from "views/common/Dialog";

export function CategoryEdit(): JSX.Element{

    const currentName = useRef<HTMLInputElement>(null);
    const currentSortNo = useRef<HTMLInputElement>(null);
    const history = useHistory();
    const cua = useContext(CtxAuth);
    const [msgArgs, setMsgArgs] = useState({type:"", text:""});
    const [submitDisabled, setSubmitDisabled] = useState<boolean>(false);
    const uri = new URL(window.location.href);
    const params = uri.searchParams;
    const [isShow, setIsShow] = useState<boolean>(false);

    function clickSave(){
        //バリデーションチェック
        let errmsg:string;
        errmsg = Validation.checkEmptyTextBox(getRef(currentName), "カテゴリ名")
        if (errmsg) {
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }
        errmsg = Validation.checkLengthOver(getRef(currentName), 100, "カテゴリ名")
        if (errmsg) {
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }
        errmsg = Validation.checkRangeNumber(+getRef(currentSortNo), 0, 1000, "表示順")
        if (errmsg) {
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }
        const categoryId = uri.searchParams.get("categoryId");
        //ボタンを押したタイミングで非活性にする
        setSubmitDisabled(true);
        if (categoryId !== null) {
            //カテゴリ情報更新
            postApiDataWithToken('/management/category/change',
            {'category_id': categoryId, 'category_name': getRef(currentName), 'category_sort_no': getRef(currentSortNo)},
            cua.getToken(),
            function(res:AxiosResponse<any>){
                switch (res.status) {
                    case 200:
                        setMsgArgs({type:mb.MSGBOX_TYPE_SUCCESS, text:"カテゴリを更新しました。"});
                        break;
                    default:
                        setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"カテゴリ更新に失敗しました。"});
                }
                //ボタンを活性にする
                setSubmitDisabled(false);
            });
        } else {
            //カテゴリ情報更新
            postApiDataWithToken('/management/category/register',
            {'category_name': getRef(currentName), 'category_sort_no': getRef(currentSortNo)},
            cua.getToken(),
            function(res:AxiosResponse<any>){
                switch (res.status) {
                    case 200:
                        setMsgArgs({type:mb.MSGBOX_TYPE_SUCCESS, text:"カテゴリを登録しました。"});
                        break;
                    default:
                        setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"カテゴリ登録に失敗しました。"});
                }
                //ボタンを活性にする
                setSubmitDisabled(false);
            });
        }
    }

    function clickDelete(){
        setIsShow(false)
        //バリデーションチェック
        const categoryId = uri.searchParams.get("categoryId");
        if (categoryId === null) {
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"存在しないカテゴリのため削除できません。"});
            return false;
        }
        if (categoryId === "0") {
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"対象のカテゴリは削除できません。"});
            return false;
        }
        //ボタンを押したタイミングで非活性にする
        setSubmitDisabled(true);
        let apiUrl = `/management/category/delete/${categoryId}`
        //カテゴリ情報削除処理
        delApiDataWithToken(apiUrl,
            {},
            cua.getToken(),
            function(res:AxiosResponse<any>){
                switch (res.status) {
                    case 200:
                        setMsgArgs({type:mb.MSGBOX_TYPE_SUCCESS, text:"カテゴリを削除しました。"});
                        break;
                    case 401:
                        setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"存在しないカテゴリです。"});
                        setSubmitDisabled(false);
                        break;
                    default:
                        setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"カテゴリ削除に失敗しました。"});
                        setSubmitDisabled(false);
                }
            }
        );
    }

    useEffect(function(){       
        const categoryId = uri.searchParams.get("categoryId");
        if (categoryId !== null) {
            let apiUrl = `/management/categories/category/${categoryId}`
            getApiDataWithToken(apiUrl,
            {},
            cua.getToken(),
            function(res:AxiosResponse<any>){
                switch (res.status) {
                    case 200:
                        setRef(currentName, res.data.category_name);
                        setRef(currentSortNo, res.data.category_sort_no);
                        break;
                    case 401:
                        setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"存在しないカテゴリです。"});
                        break;
                    default:
                        setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"画面のロードに失敗しました。"});
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //モーダルを開く
    function clickOpen(){
        setIsShow(true);
    }

    return (
        <AdminFrame>
            <div className="contents">
                <mb.MessageBox args={msgArgs}/>
                <div className="breadcrumb"><a href={process.env.PUBLIC_URL + "/admin/category/list"}>← 一覧に戻る</a></div>
                <h2 className="settings-title-h2">カテゴリー管理 &gt; 詳細</h2>
                <div className="settings-wrap-short">
                <div className="settings-block">
                    <h3 className="settings-title-h3">カテゴリー情報</h3>
                    <div className="settings-form">
                    <div className="form-row">
                        <div className="form-row-title">名前</div>
                        <div className="form-row-input"><input type="text" ref={currentName} disabled={submitDisabled}/></div>
                    </div>
                    <div className="form-row">
                        <div className="form-row-title">表示順</div>
                        <div className="form-row-input"><input type="number" min="0" ref={currentSortNo} disabled={submitDisabled}/></div>
                    </div>
                    </div>
                </div>
                <div className="control-horizon control-between margin-tb-20">
                    <button className="btn-primary" onClick={clickSave} disabled={submitDisabled}>変更を保存</button>
                    {params.get('categoryId') && <button className="btn-tertiary" onClick={clickOpen} disabled={submitDisabled}>削除</button>}
                    <Dialog isShow = {isShow} setIsShow = {setIsShow} callback={clickDelete} msg = {"カテゴリを削除してもよろしいですか？"}/>
                </div>
                </div>
            </div>
        </AdminFrame>
    )
}